<template>
  <div>
     <ul class="auto-draft-tabs">
       <li><router-link class="nav-link" :to="{name: 'monitor-drafts'}">Monitor Drafts</router-link></li>
       <li><router-link class="nav-link" :to="{name: 'files-queue'}">Files Queue</router-link></li>
     </ul>
    <transition name="fade" mode="out-in">
      <router-view></router-view>
    </transition>
  </div>
  
</template>

<script>
  export default {
    
  }
</script>

<style lang="scss" scoped>
$active-link-color: rgb(255, 91, 62);
.auto-draft-tabs{
  list-style-type:none;
  padding-left: 0;
  border-bottom: 2px solid $active-link-color;
  display: flex;
  li{
    margin-right: 3px;
  }
  li a{
    background-color: rgb(223, 223, 223);
    color: rgb(71, 71, 71);
    border-radius: 5px 5px 0 0;
    margin-bottom: 5px;
    &.active{
      background-color: $active-link-color;
      color: #fff;
      margin-bottom: 0;
      padding-bottom: 13px;
    }
  }
}
</style>